/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_ExistsInputs */



/**
* | output |
* | --- |
* | "Group name already exists." |
*
* @param {Team_Manager_Group_Name_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_exists = /** @type {((inputs?: Team_Manager_Group_Name_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom du groupe existe déjà.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Gruppenname existiert bereits.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome del gruppo esiste già.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа с таким названием уже существует.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre del grupo ya existe.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("群组名称已存在。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ名は既に存在します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह का नाम पहले से मौजूद है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O nome do grupo já existe.")
	return /** @type {LocalizedString} */ ("Group name already exists.")
});